/* tslint:disable */
/* eslint-disable */
/**
 * Tumelo API
 * This is Tumelo\'s API. It drives increased shareholder engagement by providing transparency of the organizations owned by investors and giving them a voice by allowing them to vote on important issues at these organizations.  The main uses of this API are:  * Transparency - To provide a breakdown to an investor of the organizations in which they are invested. * Voting - To provide the ability for an investor to vote on a poll concerning organizations in which they are invested.  ## Status  This API is currently available as a closed **BETA**. We invite interested parties to [give us feedback](mailto:support@tumelo.com) on this API, its documentation, or anything else about Tumelo\'s transparency service prior to the API becoming generally available.  ## Changelog  A changelog for the api can be found [here](CHANGELOG.md).  ## Access The API is available at the following URL: ``` https://api.prod.tumelo.com/v1 ```  For information on how to obtain access to the API, please [contact us](mailto:support@tumelo.com).  ## Development vs Production Habitats Development and Production environments are separated into their own habitats. Please [contact us](mailto:support@tumelo.com) when you\'re ready to go into production and require access to your company\'s live habitat.  # Using the API  ## Case Sensitivity URLs, headers, path parameters, query parameter names, and query parameter values are all case sensitive. Be careful to use the correct case when constructing requests.  ## Error Handling Requests may return an error indicating that there was a problem responding. The response will contain an HTTP status code as well as a JSON object in the following format which describes the error in more detail: ```json {   \"message\": \"Resource not found\" } ```  ## Pagination Requests that return lists and describe pagination parameters support paginated results. Results are separated into multiple pages, where the size of each page is determined by the `pageSize` query parameter. If omitted, `pageSize` defaults to 50 records. When a response includes a `nextPageToken` in the response body, this token value should be passed as a query parameter `nextPageToken` to the same endpoint in order to retrieve the next page of results. This process should be repeated until the response doesn’t include a `nextPageToken`, indicating that the end of the results has been reached.  When passing the `nextPageToken` parameter, all other filter and query parameters present in the previous request, **must** be filled. Filter parameters *must not* be changed while paginating since this will result in an error or an incorrect overall list. The `nextPageToken` will not be present in the response body if the end of the list has been reached and no further results are available.  ## String Formats The following string formats are used throughout this API.  ### date-time The valid format is date-time notation as defined by [RFC 3339, section 5.6](https://tools.ietf.org/html/rfc3339#section-5.6).  For example: `2020-11-30T10:45:28Z`  # Support If you have any technical questions relating to the Tumelo API, please [contact us](mailto:support@tumelo.com), explaining your question or issue in as much detail as possible, including the operation you were performing and the ISIN or Organization ID you were querying, as well as the results you expected and the actual results or error message you observed. You can expect a response within one business day.  ## Data Issues During development and testing in your development habitat we make available a test data set that includes some sample data constructed to illustrate functionality. It is not intended to be used for any purpose other than testing and/or demonstrating functionality, and should not be relied upon to be an accurate reflection of the underlying holdings of any real fund.  If you have any questions or concerns about the data accuracy or completeness of the data in the production environment, please [report the matter](mailto:support@tumelo.com) to us, giving as much information as possible about the issue.  # Compositions and Breakdowns  An instrument may have a composition, this means it is a fund invested in other instruments.  A breakdown is the bottom level components of a composite instrument or account. By this, we mean organizations and cash that a particular composite instrument or account is invested into either directly or through funds.  Breakdowns also have an `other` listing, this is for funds that only have partial information available, or where an instrument is not mapped to an organization. 
 *
 * The version of the OpenAPI document: 0.145.1
 * Contact: support@tumelo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstrumentReference2 } from './InstrumentReference2';
import {
    InstrumentReference2FromJSON,
    InstrumentReference2FromJSONTyped,
    InstrumentReference2ToJSON,
} from './InstrumentReference2';

/**
 * Composite instrument details for nodes of type `composite_instrument`.
 * @export
 * @interface BreakdownCompositeInstrumentDetails
 */
export interface BreakdownCompositeInstrumentDetails {
    /**
     * The ID of the node that these details relate to.
     * @type {string}
     * @memberof BreakdownCompositeInstrumentDetails
     */
    nodeId: string;
    /**
     * 
     * @type {InstrumentReference2}
     * @memberof BreakdownCompositeInstrumentDetails
     */
    instrumentReference: InstrumentReference2;
    /**
     * The title  that these details relate to.
     * @type {string}
     * @memberof BreakdownCompositeInstrumentDetails
     */
    title: string;
    /**
     * The ID of the fund manager that these details relate to.
     * @type {string}
     * @memberof BreakdownCompositeInstrumentDetails
     */
    fundManagerId?: string;
    /**
     * The time at which the composition for this instrument was valid.
     * If there is no composition for this instrument, this field will be null.
     * 
     * The valid format is date-time notation as defined by [RFC 3339, section 5.6](https://tools.ietf.org/html/rfc3339#section-5.6).
     * @type {Date}
     * @memberof BreakdownCompositeInstrumentDetails
     */
    validAt?: Date;
}

/**
 * Check if a given object implements the BreakdownCompositeInstrumentDetails interface.
 */
export function instanceOfBreakdownCompositeInstrumentDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "nodeId" in value;
    isInstance = isInstance && "instrumentReference" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function BreakdownCompositeInstrumentDetailsFromJSON(json: any): BreakdownCompositeInstrumentDetails {
    return BreakdownCompositeInstrumentDetailsFromJSONTyped(json, false);
}

export function BreakdownCompositeInstrumentDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BreakdownCompositeInstrumentDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nodeId': json['nodeId'],
        'instrumentReference': InstrumentReference2FromJSON(json['instrumentReference']),
        'title': json['title'],
        'fundManagerId': !exists(json, 'fundManagerId') ? undefined : json['fundManagerId'],
        'validAt': !exists(json, 'validAt') ? undefined : (new Date(json['validAt'])),
    };
}

export function BreakdownCompositeInstrumentDetailsToJSON(value?: BreakdownCompositeInstrumentDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nodeId': value.nodeId,
        'instrumentReference': InstrumentReference2ToJSON(value.instrumentReference),
        'title': value.title,
        'fundManagerId': value.fundManagerId,
        'validAt': value.validAt === undefined ? undefined : (value.validAt.toISOString()),
    };
}

